// extracted by mini-css-extract-plugin
export default {"button":"Button_button__t06d4","primary":"Button_primary__ZMUOP","remove":"Button_remove__n-h80","small":"Button_small__vFjBd"};